module.exports = __webpack_public_path__ + "static/img/34.fcc3319.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/AzureImplementation/34.png
// module id = JzlF
// module chunks = 1